export default {
  //button check
  getBtnText(role, status) {
    //服务商
    if (role === 1) {
      return { submitIsShow: false };
    } else {
      //企业
      if (parseInt(status) === 1 || parseInt(status) === 1) {
        return { submitIsShow: true, isShowRadio: true };
      } else {
        return { submitIsShow: false };
      }
    }
  },
};
